import { Card, Col, Row } from "react-bootstrap";
import { IComplianceInvestigationActionOrInstructionDetails } from "../../../../api/ComplianceInvestigation/IComplianceInvestigationActionsAndInstructions";
import EpaField2Rows from "../../../../leap-components/EpaField2Rows";
import {
  ActionOrInstructionIcon,
  LicenseeReturnIcon,
} from "../../../../leap-components/icons/LeapIcons";

interface HeaderProps {
  actionOrInstruction: IComplianceInvestigationActionOrInstructionDetails;
}

const ActionOrInstructionHeader = ({ actionOrInstruction }: HeaderProps) => {
  return (
    <Card className="flex-fill w-100">
      <Card.Header></Card.Header>
      <Card.Body className="pt-0">
        <Row>
          <Col className="col-12 col-md-6">
            <table className="no-border" style={{ marginTop: "0.6rem" }}>
              <tbody>
                <tr>
                  <td>
                    <ActionOrInstructionIcon />
                  </td>
                  <td>
                    <h2>
                      {`Action / Instruction: ${actionOrInstruction.reference}`}
                    </h2>
                  </td>
                </tr>
              </tbody>
            </table>
            <div className="d-md-none" style={{ height: "20px" }}></div>
          </Col>
          <Col className="col-4 col-md-2">
            <EpaField2Rows
              label={"Reference No."}
              value={actionOrInstruction.reference}
            />
          </Col>
          <Col className="col-4 col-md-2">
            <EpaField2Rows
              label={"Status"}
              value={actionOrInstruction.status}
            />
          </Col>
          <Col className="col-4 col-md-2">
            <EpaField2Rows
              label={"Authorisation Version"}
              value={actionOrInstruction.licence_regno}
            />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default ActionOrInstructionHeader;
